exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status-popover.popover{font-size:1rem;min-width:15em;max-width:95%;border-color:#222;border-color:var(--border, #222);border-style:solid;border-width:1px;border-radius:5px;border-radius:var(--tooltipRadius, 5px);box-shadow:2px 2px 3px rgba(0,0,0,.5);box-shadow:var(--popupShadow)\n}\n.status-popover.popover .Status.Status{border:none\n}\n.status-popover.popover .status-preview-no-content{padding:1em;text-align:center\n}\n.status-popover.popover .status-preview-no-content i{font-size:2em\n}", ""]);

// exports
